import React, { useEffect, useRef, useState } from 'react'
import { FilePond, registerPlugin } from 'react-filepond'

import 'filepond/dist/filepond.min.css'
import { humanFileSize } from '../../helpers/fileHelper';
import { Button } from "react-bootstrap";
import { ApiURLs, API_BASE_URL } from '../../common/url';
import { AddIcon, DocIcon, EditIcon, FilePondStatus } from './filePondHelper';
import { MetaDataPopup } from './metaDataPopup';
import { SaveFilesButton } from './saveFilesButton';
import { useForm } from 'react-hook-form';
import { AppToast } from '../../lib/toast';
import { GetSafeJsx, renderFileIconClass } from '../../common/commonHelper';
import { IconTypes, RenderIcons } from '../controls/icons';
import { useDispatch, useSelector } from 'react-redux';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { addTags, addTagsToAllFiles, browse, cancelButton, DocumentsPage, docUpdateToasterMessage, dragndrop, editTags, errorIcon, fileLabel, fileNameError, files, filesExceeded, fileUploadFailed, HomePage, isInvalidMessage, of, sizeLimitExceeded, supported, svg, tagAll, tagAllMessage, uploadCompleted, uploaded, uploading, uploadLimit } from '../../common/labelConstants';
import { getConfiguredLabel } from '../../common/commonHelper';
import { getTemplate } from '../../store/template/templateSlice';
import { DataTypes, TemplateTypes } from '../../common/constants';
import { Button as PButton } from 'primereact/button';
import { usePermissions } from '../../hooks/usePermissions';
import { AppTooltip } from '../controls/tooltip';
import { MultiSelect } from "primereact/multiselect";

registerPlugin(FilePondPluginFileValidateType);


registerPlugin(FilePondPluginFileValidateSize);


const filePondData = {

  stylePanelLayout: 'compact',
  name: "files",
  labelTapToRetry: "Tap To Retry",
  chunkSize: "_chunk-size",
}

const _props = {
  save: ({ allFilesProcessed = false, metadataForm = {}, fileList = [], onSaveSuccess = () => { }, getFileErrors = (file, formErrors) => {
    return {
      isFileNameHasError,
      isFileHasMetadataError
    }
  } }) => {
    return <></>
  },
  cancel: (onCancelClick) => {
    return <></>
  },
  metadataControls: [],
  allowFileTagging: false,
  allowFileRename: false,
  config: { allowedFileSizeInMb: 5, allowedMaxFilesInSingleUpload: 2, allowedMimeTypes: [] },
  onUploadComplete: ({ isUploadComplete = false, fileList = [], metadataForm = {}, onSaveSuccess_callBack = () => { } }) => {

  },
  isDocUpdate: false
}

function UploadFile(props = _props) {
  const [fileList, setFiles] = useState([]);
  const [fileProgress, setFileProgress] = useState({})
  const [showPopup, setShowPopup] = useState(false);
  const [editShowPopup, setEditShowPopup] = useState(false);
  const [currentEditFile,setCurrentEditFile] = useState(null)
  const [popupTitle, setPopupTitle] = useState('');
  const [tagedFiles, setTagedFiles] = useState([]);
  const [isAnyFileTagged, setIsAnyFileTagged] = useState(false)
  const token = useSelector(s => s.auth.token)
  const form = useForm()
  const metadataForm = useForm()
  const { register, unregister, getValues, trigger: triggerMetaformValidation, formState: { errors: fileMetadataErrors }, setValue: setMetadataFormValue } = metadataForm;
  const pond = useRef(null);

  // const chunkDefinedSize = fileList.reduce((x, y) => {
  //   return x + y.file.fileSize
  // }, 0)
  const [isMounted, setIsMounted] = useState(true);
  const controls = props.metadataControls || [];
  const [allFilesProcessed, setAllFilesProcessed] = useState(false)
  const uploadMessageLabel = `<span class="upload_icon" >${props.config.upload}</span><p>${props.config.dragnDrop} <span class="filepond--label-action">${props.config.browse}</span></p><span class="BulkSupportedText">${props.config.supportedFilesMsg || ""}</span>`

  const dispatch = useDispatch();

  const filePondEventListeners = [{
    name: 'FilePond:processfiles',
    event: () => {
      if (isMounted) {
        setFileProgress((_progress) => {
          const p = { ..._progress }
          Object.keys(p).map(x => {
            p[x].progress = 100
          });

          return p;
        })
        setAllFilesProcessed(true)


      }
    }
  },
  {
    name: 'FilePond:removefile',
    event: (fileToBeRemoved) => {
      if (isMounted) {
        unregister(fileToBeRemoved.detail.file.id)
      }
    }
  }]
  const errIcon = <svg id="cancel" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 14 14">
  <path id="Path_189" data-name="Path 189" d="M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0ZM7,12.727A5.727,5.727,0,1,1,12.727,7,5.734,5.734,0,0,1,7,12.727Z" fill="#ef2653"/>
  <path id="Path_190" data-name="Path 190" d="M92.848,86.547a.636.636,0,0,0-.9,0L89.7,88.8l-2.25-2.25a.636.636,0,0,0-.9.9L88.8,89.7l-2.25,2.25a.636.636,0,1,0,.9.9L89.7,90.6l2.25,2.25a.636.636,0,0,0,.9-.9L90.6,89.7l2.25-2.25A.636.636,0,0,0,92.848,86.547Z" transform="translate(-82.698 -82.697)" fill="#ef2653"/>
  </svg>;
  useEffect(() => {
    //register filepond events
    filePondEventListeners.map(x => document.addEventListener(x.name, x.event))
    return () => {
      //unregister filepond events
      filePondEventListeners.map(x => document.removeEventListener(x.name, x.event))
    }
  }, []);





  function getProgress(x) {
    return fileProgress && fileProgress[x.id] ? fileProgress[x.id] : {}
  }

  function handleFileProcessed(){
    if(props.isDocUpdate){
      if(typeof props.setUploadCompleteCb === 'function'){
        props.setUploadCompleteCb(true)
      }
    }
  }

  function handleSetFiles(files) {
    props?.setFilesCb(files)
    if (Array.isArray(files) && files.length == 0) {
      resetToDefault()
    }

    setFiles((oldFiles) => {

      if (files.length > oldFiles.length) {
        setAllFilesProcessed(false)
      }

      const f_files = files.filter(file => {
        const v = validateFile(file)
        const assert = v.validFileType && v.validFileSize
        if (!assert) {
          pond.current.removeFile(file)
        }
        return v.isValid;
      });

      return f_files.map(file => {
        const existingFile = oldFiles.find(f => f.file.id === file.id);
        if (existingFile) {
          return existingFile;
        }
        else {
          if (props.allowFileTagging) {
            controls[0]?.fields.forEach(element => {
              register(`${file.id}.${element.field}`, element?.edit?.rules)
            });
          }
          if (props.allowFileRename) {
            register(`${file.id}.fileName`, {
              required: {
                value: true,
                message: "You must enter your fileName"
              }
            })
          }
          setMetadataFormValue(`${file.id}.fileName`, file.filenameWithoutExtension)
          return { file: file, fileExtension: file.fileExtension, fileName: file.filenameWithoutExtension, fileSize: humanFileSize(file.fileSize), metadata: null }
        }

      })
    })
  }
  let fileL = getConfiguredLabel(HomePage, fileLabel);
  let isInvalidM = getConfiguredLabel(HomePage, isInvalidMessage);
  let docUpdateToasterM = getConfiguredLabel(HomePage, docUpdateToasterMessage)
  let sizeLimitExceededMessage = getConfiguredLabel(HomePage, sizeLimitExceeded)
  function validationMsg(file) {
    const v = validateFile(file);

    // Show error for filename validation first
    if (!v.validFileName) {
      AppToast.Toast.error({ title: getConfiguredLabel(HomePage, fileUploadFailed), message: v.fileNameError, delayInMs: 5000 });
      return;
    }

    // Then file type
    if (!v.validFileType) {
      AppToast.Toast.error({ title: getConfiguredLabel(HomePage, fileUploadFailed), message: v.fileTypeError, delayInMs: 5000 });
      return;
    }

    // Then file size
    if (!v.validFileSize) {
      AppToast.Toast.error({ title: getConfiguredLabel(HomePage, fileUploadFailed), message: v.fileSizeError, delayInMs: 5000 });
      return;
    }
  }

  function handleSetMetaData(data = {}) {
    tagedFiles.map(file => {
      file.metadata = data.metadata;
      file.fileAccessibility = data.fileAccessibility;
      file.role=data.role;
      setMetadataFormValue(file.file.id, { ...data.metadata, fileName: file.fileName, fileAccessibility: data.fileAccessibility, role: data.role }, { shouldValidate: true })
      triggerMetaformValidation(file.file.id);
      return file;
    })
    setIsAnyFileTagged(true);
    setShowPopup(false)
    setEditShowPopup(false)
  }

  function handleAddMetaDataPopup(file, buttonType, action, index) {

    if (buttonType === 1) {
      setPopupTitle(action === 'add' ? getConfiguredLabel(HomePage, addTags) : getConfiguredLabel(HomePage, editTags))
    }

    //for all files
    if (buttonType === 0) {
      setPopupTitle(`${getConfiguredLabel(HomePage, addTagsToAllFiles)}`)
    }
    const selectedFiles = Array.isArray(file) ? file : [file];

    if (action === 'edit') {
      setCurrentEditFile(index)
      setEditShowPopup(!editShowPopup)
    }
    else if (action === 'add') {
      form.reset({});
      setShowPopup(!showPopup)
    }

    setTagedFiles(selectedFiles);

  }

  function getFileErrors(_file, formErrors) {
    const error_obj = formErrors[_file.file.id];
    const isFileNameHasError = formErrors[_file.file.id]?.fileName ? true : false;
    const totalErrors = Object.keys(error_obj || {}).length;
    const isFileHasMetadataError = ((isFileNameHasError && totalErrors > 1) || !isFileNameHasError && totalErrors > 0)
    return {
      isFileNameHasError,
      isFileHasMetadataError
    };
  }

  function renderFileList(_files) {
    let totalUploaded = _files.filter(file => parseInt(getProgress(file.file).progress) === 100).length

    return <div className='container'>
      {!props.isDocUpdate && _files.length > 0 && <div className='files_tagbtn'>
        <span className='files_tagNumber'>
          {getConfiguredLabel(HomePage, uploaded)} <strong>{totalUploaded}  </strong> {getConfiguredLabel(HomePage, of)} <strong> {_files.length}</strong>  {getConfiguredLabel(HomePage, files)}
        </span>
        {
          props.allowFileTagging &&
          <>
            <span className='button_wrapper'>
              <Button onClick={() => handleAddMetaDataPopup(_files, 0, 'add')} className='tagall_btn' > <span dangerouslySetInnerHTML={{ __html: getConfiguredLabel(svg, tagAll) }}></span>{getConfiguredLabel(HomePage, tagAllMessage)}</Button>
            </span>
            {showPopup &&
              <MetaDataPopup form={form} controls={controls} setShowPopup={setShowPopup} show={showPopup} title={popupTitle}
                onAddClick={handleSetMetaData} key={11211}
              />}

          </>
        }
      </div>
      }
      {

        _files.map((_file, index) => {
          let _progress = getProgress(_file.file)
          let progressPercent = parseInt(_progress.progress || 0)
          const { isFileHasMetadataError, isFileNameHasError } = getFileErrors(_file, fileMetadataErrors)
          return (
            <div key={index} className={`uploaded_file ${isFileHasMetadataError || (props.bulkErrorList && props.bulkErrorList?.length > 0)  ? 'error-form-field' : ''}`}>

              <div className='row'>

                <div className={(props.allowFileRename || props.allowFileTagging) ? 'col-xl-5 col-lg-12 col-md-12 col-sm-12' : 'col-md-12'}>
                  <div className={`uploaded_file_left pos_relative ${progressPercent === 100 ? 'upload_completed_file' : ''}`} >
                    <div className='col_1'>
                      <span className='doc_icon'>
                        <span className={renderFileIconClass(_file.fileExtension)}></span>
                      </span>
                    </div>
                    <div className="col_2">
                      <div className='file_details'>
                        <div className='file_name'>
                          {_file.fileName}.{_file.fileExtension}
                        </div>
                        <div className='file_size'>
                          {_file.fileSize}
                        </div>
                      </div>
                      <div className='upload_progeress'>
                        {progressPercent === 100 ? <span >
                          {RenderIcons(IconTypes.CheckCircle)}
                          {/* <i style={{ color: 'green', marginRight: '5px' }} className="fa fa-check-circle" aria-hidden="true"></i> */}
                          <span className='upload_complete'>{getConfiguredLabel(HomePage, uploadCompleted)}</span>
                        </span> : <span className='progress_value'>{getConfiguredLabel(HomePage, uploading)} {progressPercent}%</span>}
                      </div>
                    </div>
                    <div className='col_3 text-center'>
                      <span className='close_file_icon' onClick={() => {
                        pond.current.removeFile(_file.file)
                      }}>
                        {RenderIcons(IconTypes.DeleteIcon_File)}
                      </span>
                      {_progress.status === FilePondStatus.PROCESSING_ERROR &&
                        <span className='retryIcon' onClick={() => {
                          pond.current.processFile(_file.file)
                        }}>{RenderIcons(IconTypes.Reload)} </span>}
                    </div>


                  </div>
                  {
                    <div className="progress">
                      <div className="progress-bar progress-bar-striped progress-bar-animated  bg-success" role="progressbar" style={{ width: progressPercent + '%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{progressPercent}%</div>
                    </div>
                  }
                  <div>
                  </div>
                </div>
                {(props.allowFileTagging || props.allowFileRename) && <div className='col-xl-7 col-lg-12 col-md-12 col-sm-12'>
                  <div className='uploaded_file_right'>
                    {props.allowFileRename && <div className='input_group'>
                      <input type={'text'} className={isFileNameHasError ? 'p-invalid ' : ''} value={_file.fileName} onChange={(e) => {
                        let fileObject = fileList[index];
                        fileObject.fileName = e.target.value.trimStart()
                        setFiles([...fileList])
                        setMetadataFormValue(`${_file.file.id}.fileName`, fileObject.fileName.trim())
                        triggerMetaformValidation(`${_file.file.id}.fileName`)
                      }} />
                      {/* {_file.metadata ? <span className='tags_added'></span> : ''} */}
                      {isFileNameHasError ? <small  className='error-text '>{errIcon} {getConfiguredLabel(DocumentsPage, fileNameError)}</small> : null}
                    </div>
                    }
                    {
                      props.allowFileTagging && <><span className='add_tags_icon' onClick={() => { handleAddMetaDataPopup(_file, 1, !_file.metadata ? 'add' : 'edit', index) }}>
                        <button>{!_file.metadata ? <span>{RenderIcons(IconTypes.AddIcon_File)}</span> : <span>{RenderIcons(IconTypes.EditIcon_File)}</span>}</button>
                      </span>
                      {(index==currentEditFile) && <MetaDataPopup form={form} controls={controls} setShowPopup={setEditShowPopup} show={editShowPopup} title={popupTitle} fileData={_file}
                          onAddClick={handleSetMetaData}
                        />}
                      </>
                    }
                  </div>
                </div>}
              </div>
            </div>
          )
        })
      }
    </div>
  }

  /**
   * Extract allowed extensions from allowed MIME types (mirrors backend)
   * Maps MIME types to their allowed extensions
   */
  function allowedExtensionsFromAllowedMimes(allowedMimeTypes = []) {
    const MIME_TO_EXT = {
      "text/plain": ["txt"],
      "application/pdf": ["pdf"],
      "application/vnd.ms-powerpoint": ["ppt"],
      "application/vnd.openxmlformats-officedocument.presentationml.presentation": ["pptx"],
      "application/msword": ["doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ["docx"],
      "application/vnd.ms-excel": ["xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"],
      "image/jpeg": ["jpg", "jpeg"],
      "image/png": ["png"],
      "image/svg+xml": ["svg"],
      "image/gif": ["gif"],
      "image/bmp": ["bmp"],
      "image/tiff": ["tif", "tiff"],
      "video/mp4": ["mp4"],
      "video/x-msvideo": ["avi"],
      "video/x-matroska": ["mkv"],
      "video/quicktime": ["mov"],
      "video/x-ms-wmv": ["wmv"],
      "video/x-flv": ["flv"],
      "video/webm": ["webm"],
      "audio/wav": ["wav"],
      "audio/mpeg": ["mp3"],
      "audio/aac": ["aac"],
      "audio/flac": ["flac"],
      "audio/mp4": ["m4a"],
      "audio/ogg": ["ogg"],
      "audio/x-ms-wma": ["wma"],
      "application/zip": ["zip"],
      "application/x-tar": ["tar"],
      "application/gzip": ["gz"],
      "application/x-rar-compressed": ["rar"],
      "application/x-7z-compressed": ["7z"]
    };

    const out = new Set();
    for (const m of allowedMimeTypes || []) {
      const mime = String(m || "").toLowerCase().trim();
      const exts = MIME_TO_EXT[mime];
      if (!exts) continue;
      exts.forEach((e) => out.add(e));
      }
    return [...out];
  }



  function splitLastExtension(fullName) {
    if (typeof fullName !== "string") return { baseName: "", ext: "" };

    const lastDot = fullName.lastIndexOf(".");
    // No dot, dot is first char (".bashrc") => treat as no extension like Node's extname does for ".bashrc"
    if (lastDot <= 0) return { baseName: fullName, ext: "" };

    const extWithDot = fullName.slice(lastDot); // includes "."
    const ext = extWithDot.length > 1 ? extWithDot.slice(1).toLowerCase() : "";
    const baseName = fullName.slice(0, lastDot);
    return { baseName, ext };
  }


  function validateFullFileName(fullName, opts = {}) {
    const maxLength = Number.isFinite(opts.maxLength) ? opts.maxLength : 180; // default
    const allowedExt = Array.isArray(opts.allowedExtensions) ? opts.allowedExtensions : [];

    if (typeof fullName !== "string" || fullName.length === 0) {
      return { ok: false, error: "Missing file name." };
    }


    const { baseName, extension } = splitLastExtension(fullName);

    
    if (baseName.length > maxLength) {
      return { ok: false, error: `File name exceeds maximum length (${maxLength}).` };
    }

    if (/[.\s]+$/.test(baseName)) {
      return { ok: false, error: "Trailing spaces or dots in file name are not allowed." }; // 
    }

    // No control chars
    if (/[\x00-\x1F\x7F]/.test(fullName)) {
      return { ok: false, error: "File name contains invalid characters." };
    }

    

    // No paths/  
    if (fullName.includes("/") || fullName.includes("\\") || fullName.includes("..")) {
      return { ok: false, error: "Invalid file name." };
    }

    // Must have extension
    const lastDotIndex = fullName.lastIndexOf(".");
    const ext = lastDotIndex > 0 ? fullName.slice(lastDotIndex + 1).toLowerCase() : "";

    if (!ext) {
      return { ok: false, error: "File extension is required." };
    }

    // Optional allowlist of extensions
    if (allowedExt.length > 0) {
      const set = new Set(allowedExt.map((e) => String(e).toLowerCase()));
      if (!set.has(ext)) {
        return { ok: false, error: "File extension is not allowed." };
      }
    }

    // Block multi-dot masquerade: "image.jpg.php"
    const parts = fullName.split(".");
    if (parts.length >= 3) {
      // reject consecutive dots like "a..pdf"
      if (parts.some((p) => p.length === 0)) {
        return { ok: false, error: "File name must not contain consecutive dots." };
      }

      const prevExt = parts[parts.length - 2].toLowerCase();
      const suspiciousPrev = new Set([
        "jpg", "jpeg", "png", "gif", "bmp", "tif", "tiff", "svg",
        "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt",
        "zip", "rar", "7z", "tar", "gz"
      ]);

      if (suspiciousPrev.has(prevExt)) {
        return { ok: false, error: "File name must not contain multiple extensions." };
      }
    }

    return { ok: true, ext };
  }

  /**
   * Validates file against all configured rules from database (props.config)
   * Returns validation result with specific error messages
   */
  function validateFile(file) {
  const result = {
    isValid: true,
    validFileName: true,
    validFileType: true,
    validFileSize: true,
    fileNameError: "",
    fileTypeError: "",
    fileSizeError: ""
  };

  if (!file) {
    return result;
  }

  const filename = file.filename || "";
    const mimeType = (file.fileType || "").toLowerCase();
  const fileSize = file.fileSize || 0;
  const allowedMimeTypes = props.config.allowedMimeTypes || [];
  const allowedFileSizeInMb = props.config.allowedFileSizeInMb || 100;
  const maxLength = props.config.allowedMaxCharacterInFileName || 180;

    // 1. Validate filename format
  const filenameValidation = validateFullFileName(filename, {
      maxLength: maxLength,
    allowedExtensions: allowedExtensionsFromAllowedMimes(allowedMimeTypes)
  });

  if (!filenameValidation.ok) {
    result.validFileName = false;
    result.fileNameError = filenameValidation.error;
    result.isValid = false;
  }

    // 2. Validate file type (MIME) against whitelist
    const allowedSet = new Set((allowedMimeTypes || []).map(m => String(m).toLowerCase().trim()));
    if (allowedSet.size > 0 && !allowedSet.has(mimeType)) {
      result.validFileType = false;
      result.fileTypeError = `File type is not allowed.`;
      result.isValid = false;
  }

    // 3. Validate file size
  const maxSizeBytes = allowedFileSizeInMb * 1024 * 1024;
  if (maxSizeBytes > 0 && fileSize > maxSizeBytes) {
    result.validFileSize = false;
      result.fileSizeError = `File size exceeds allowed limit (${allowedFileSizeInMb} MB).`; // {} config db 
    result.isValid = false;
  }

  return result;
}

  function resetToDefault() {
   props.handleSetErrors &&  props?.handleSetErrors([])
    setFiles([])
    setFileProgress({})
    setTagedFiles([])
    setAllFilesProcessed(false)
    setIsAnyFileTagged(false)
  }



  let limitMessage = getConfiguredLabel(HomePage, uploadLimit);
  let exceededfiles = getConfiguredLabel(HomePage, filesExceeded)

  //warning for files limit
  useEffect(() => {
    const listener_file_warn = 'FilePond:warning';
    const ev = (event, file) => {
      if (event && event.detail && event.detail.error && event.detail.error.body === 'Max files')
        AppToast.Toast.error({ title: getConfiguredLabel(HomePage, fileUploadFailed), message: `${limitMessage} ${props.config.allowedMaxFilesInSingleUpload} ${exceededfiles}.`, delayInMs: 4000 })
    }
    document.addEventListener(listener_file_warn, ev);
    return () => {
      document.removeEventListener(listener_file_warn, ev);
    }
  }, [])

  function onSaveSuccess() {
    resetToDefault();
  }
  const onCancelClick = () => {
    resetToDefault();
    fileList.map(file => {
      file.file.abortProcessing()
    })
  }
  if (typeof props.onUploadComplete === 'function' && allFilesProcessed) {
    props.onUploadComplete({
      isUploadComplete: allFilesProcessed,
      fileList: fileList,
      metadataForm: metadataForm,
      onSaveSuccess_callBack: onSaveSuccess
    })
  }
  const save = typeof props.save === 'function' ? props.save({ allFilesProcessed, metadataForm, fileList, onSaveSuccess, getFileErrors }) : null
  const cancel = typeof props.cancel === 'function' ? props.cancel(onCancelClick) : null
  const fileLimitReached = fileList.length === props.config.allowedMaxFilesInSingleUpload;

  return (<>
    <div className={`drag_wrapper ${props.config.allowedMaxFilesInSingleUpload === 1 ? 'Bulk_drag_wrapper' : ''}  ${fileList.length > 0 ? 'with_files' : ''} ${fileLimitReached ? "noBorder" : " "}`}>
      <div className='row'>
        <div className={`col-lg-12 ${fileLimitReached ? "files-not-allowed" : "files-allowed rc_file_uploader"}`}>
          <FilePond
            fileSizeBase={1024}
            stylePanelAspectRatio={0.15}
            ref={pond}
            acceptedFileTypes={props.config.allowedMimeTypes}
            allowFileSizeValidation={true}
            maxFileSize={`${+props.config.allowedFileSizeInMb * 1024 * 1024}`}
            credits={false}
            onerror={(err, file, status) => {
              setFileProgress({
                ...fileProgress,
                [file.id]: { status: FilePondStatus.PROCESSING_ERROR, progress: 0.0 }
              })
            }}

            onprocessfileprogress={(currentFile, _p) => {
              setFileProgress((p) => {
                const obj_progress = { ...p }

                obj_progress[currentFile.id] = {

                  status: currentFile.status,
                  progress: currentFile.status === FilePondStatus.PROCESSING_COMPLETE ? 100 : (parseFloat(_p) * 100).toFixed(2)
                }
                return obj_progress
              })
            }}
            allowFileTypeValidation={true}
            onprocessfiles={handleFileProcessed}
            onaddfilestart={validationMsg}
            files={fileList.map(x => x.file)}
            onupdatefiles={(newFiles) => { handleSetFiles(newFiles) }}
            allowMultiple={true}
            maxFiles={props.config.allowedMaxFilesInSingleUpload}
            server={{
              url: API_BASE_URL + ApiURLs.Document.Upload,
              headers: {
                "_chunk-size": 1000000,
                "authorization": token
              }
            }}
            // beforeDropFile = {validateFile}
            stylePanelLayout={filePondData.stylePanelLayout}
            name={filePondData.name}
            labelIdle={uploadMessageLabel}
            styleProgressIndicatorPosition={'right'}
            chunkUploads={true}
            chunkForce={true}
            labelTapToRetry={filePondData.labelTapToRetry}
            chunkSize={1000000}
            maxParallelUploads={10}
            allowDrop={true}
            onremovefile={(e, file) => {
              setFiles((files) => {
                file.abortProcessing();
                delete fileProgress[file.id]
                const allProcessed = Object.keys(fileProgress).map(x => fileProgress[x].progress).filter(x => parseInt(x) === 100).filter(x => x !== file.id).length >= files.length - 1
                setAllFilesProcessed(allProcessed)
                return files.filter(x => x.file.id !== file.id)
              })
            }}
          />
        </div>
      </div>
      {renderFileList(fileList)}
      {props.bulkErrorList && <div>
        {fileList.length > 0 && props.bulkErrorList?.length > 0 ? <ul>
          {props.bulkErrorList?.map((value) => (
            <li className='error-text'>{value && value.message}</li>
          ))}
        </ul> : null}</div>}

    </div>
    <div>{fileList.length > 0 && <div className='cancel-save-btns'>
      {GetSafeJsx(cancel)}
      {GetSafeJsx(save)}
    </div>}</div>
  </>
  )
}
export default UploadFile;